import React from 'react';
import {createStackNavigator} from '@react-navigation/stack';

import {NavigationKey} from '../config/navigation.config';
import {AdminPatientsScreen} from '../../screens';

import {NavigationTitle} from '../config/navigationTitle';

const {Navigator, Screen} = createStackNavigator();

const AdminPatientsStackNavigator = () => {
  return (
    <Navigator initialRouteName={NavigationKey.ADMIN_PROFILES_LIST}>
      <Screen
        name={NavigationKey.ADMIN_PROFILES_LIST}
        component={AdminPatientsScreen}
        options={{
          headerShown: false,
          title: NavigationTitle.ADMIN_PROFILES_LIST,
        }}
      />
    </Navigator>
  );
};

export default AdminPatientsStackNavigator;
